import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaChessKnight, FaLightbulb, FaHandshake, FaChartLine, FaCogs, FaRocket, FaGlobeAmericas, FaLeaf, FaExchangeAlt, FaSearchPlus, FaUsers, FaMoneyBillWave, FaRegLightbulb, FaRegChartBar, FaRegCompass, FaRegEdit } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideInLeft = keyframes`
  from { opacity: 0; transform: translateX(-100px); }
  to { opacity: 1; transform: translateX(0); }
`;

const slideInRight = keyframes`
  from { opacity: 0; transform: translateX(100px); }
  to { opacity: 1; transform: translateX(0); }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
`;

const FAQContainer = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  background: white;
  padding: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

const FAQContent = styled.div`
  flex: 1;
  animation: ${slideInRight} 1s ease-in-out;
`;

const FAQItem = styled.div`
  background: #ffffff;
  margin: 15px 0;
  border-bottom: 1px solid #d1d5db;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  opacity: 0;
  transform: translateY(20px);
  animation: ${fadeUp} 0.5s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};

  &:hover {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Question = styled.div`
  background: #f9fafb;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: #eef1f6;
  }
`;

const Answer = styled.div`
  padding: 15px;
  font-size: 16px;
  color: #555;
  background: #ffffff;
  border-top: 1px solid #d1d5db;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

const Icon = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: #ffc107;
  transition: transform 0.3s ease;
  ${({ isOpen }) => isOpen && "transform: rotate(180deg);"}
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  animation: ${fadeUp} 0.5s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};
  height: 100%;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const ServiceIcon = styled.div`
  font-size: 42px;
  color: ${props => props.color || "#ffc107"};
  margin-bottom: 20px;
`;

const ServiceTitle = styled.h4`
  font-weight: 700;
  margin-bottom: 15px;
  color: #333;
`;

const ServiceDescription = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
`;

const AdvantageCard = styled.div`
  padding: 25px 15px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const AdvantageIcon = styled.div`
  font-size: 48px;
  margin-bottom: 15px;
  color: ${props => props.color || "#ffc107"};
`;

const Section = styled.section`
  padding: 80px 0;
  background: ${props => props.background || "white"};
`;

const ProcessStep = styled.div`
  display: flex;
  margin-bottom: 40px;
  opacity: 0;
  transform: translateY(30px);
  animation: ${fadeUp} 0.6s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const StepNumber = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom right, #ffc107, #fd7e14);
  color: white;
  font-size: 24px;
  font-weight: bold;
  border-radius: 50%;
  margin-right: 25px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

const StepContent = styled.div`
  flex-grow: 1;
`;

const StepTitle = styled.h4`
  font-weight: 700;
  margin-bottom: 10px;
  color: #333;
`;

const StepDescription = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 0;
`;

const ConseilStrategie = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const faqSection = document.getElementById("faq-section");
            if (faqSection) {
                const rect = faqSection.getBoundingClientRect();
                if (rect.top < window.innerHeight * 0.8 && rect.bottom > 0) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqData = [
        {
            question: "En quoi consiste le service de \"Conseil et Stratégie d'Entreprise\" ?",
            answer: "Ce service va au-delà des missions comptables traditionnelles. Il s'agit d'un accompagnement stratégique sur mesure pour vous aider à prendre les meilleures décisions pour le développement et la pérennité de votre entreprise. Nous vous aidons à définir votre vision, à fixer des objectifs clairs, à identifier les opportunités de croissance, à optimiser votre performance et à anticiper les risques."
        },
        {
            question: "À qui s'adresse ce service ?",
            answer: "Ce service s'adresse à tous types d'entreprises, quels que soient leur taille et leur secteur d'activité : Créateurs d'entreprise : Pour bien démarrer, structurer leur projet et élaborer un business plan solide. TPE/PME : Pour optimiser leur gestion, développer leur activité, améliorer leur rentabilité et préparer l'avenir. Grandes entreprises : Pour challenger leur stratégie, identifier de nouvelles opportunités, optimiser leur organisation et accompagner leurs projets de transformation. Entreprises en difficulté: pour identifier les causes des difficultés, élaborer un plan de redressement, et négocier avec les créanciers. Entreprises en phase de croissance : Pour structurer cette croissance, gérer l'augmentation des effectifs, optimiser les processus et lever des fonds si nécessaire. Entreprises en phase de transmission/cession : Pour préparer la transmission, valoriser l'entreprise, optimiser les aspects fiscaux et juridiques, et accompagner le repreneur."
        },
        {
            question: "Quelle est la différence entre ce service et la mission comptable classique ?",
            answer: "La mission comptable classique se concentre sur la tenue des comptes, la production des états financiers et le respect des obligations légales. Le conseil en stratégie, quant à lui, est une mission proactive et orientée vers l'avenir. Il utilise les données financières (mais pas seulement) comme base pour analyser la situation, identifier les leviers de performance et formuler des recommandations stratégiques."
        },
        {
            question: "Quels sont les bénéfices concrets de ce service pour mon entreprise ?",
            answer: "Les bénéfices sont multiples : Amélioration de la performance : Optimisation de la rentabilité, de la croissance et de la compétitivité. Prise de décision éclairée : Décisions basées sur des analyses objectives et des données fiables. Anticipation des risques : Identification et gestion proactive des risques. Gain de temps et d'efficacité : Optimisation des processus et de l'organisation. Vision claire et partagée : Alignement de l'équipe sur des objectifs communs. Accompagnement personnalisé : Un expert à vos côtés pour vous conseiller et vous soutenir. Meilleure valorisation de l'entreprise: en cas de cession ou de recherche d'investisseurs. Amélioration de la relation avec les partenaires financiers: (banques, investisseurs) grâce à une meilleure présentation de la stratégie et des perspectives de l'entreprise."
        },
        {
            question: "Quels types de conseils proposez-vous ?",
            answer: "Notre offre de conseil couvre un large éventail de domaines : Stratégie générale : Définition de la vision, de la mission, des valeurs et des objectifs stratégiques. Stratégie de croissance : Identification des opportunités de développement (nouveaux marchés, nouveaux produits/services, croissance externe, etc.). Stratégie financière : Optimisation de la structure financière, recherche de financements, gestion de la trésorerie, analyse de la rentabilité, élaboration de business plans. Stratégie digitale : Définition d'une stratégie de présence en ligne, optimisation de la visibilité, développement de nouveaux canaux de vente. Stratégie RH : Optimisation de l'organisation, gestion des talents, recrutement, formation, politique de rémunération. Stratégie commerciale: définition de la politique commerciale, optimisation de la force de vente, développement de la relation client. Stratégie de développement durable / RSE: intégration des enjeux sociaux et environnementaux dans la stratégie de l'entreprise. Stratégie d'innovation: identification des opportunités d'innovation, mise en place de processus d'innovation, gestion de la propriété intellectuelle. Gestion de crise : Accompagnement dans les situations difficiles (difficultés financières, conflits internes, etc.). Pilotage de la performance: mise en place de tableaux de bord, d'indicateurs clés de performance (KPI), et de processus de reporting."
        },
        {
            question: "Proposez-vous un accompagnement à la création d'entreprise ?",
            answer: "Oui, nous accompagnons les créateurs d'entreprise à chaque étape de leur projet : Étude de marché : Validation du potentiel du projet. Choix de la forme juridique : Optimisation du statut juridique, fiscal et social. Élaboration du business plan : Construction d'un dossier solide pour convaincre les partenaires financiers. Recherche de financements : Accompagnement dans la recherche de financements (prêts bancaires, aides publiques, investisseurs, etc.). Formalités administratives : Prise en charge des démarches de création. Suivi post-création : Accompagnement dans les premiers mois d'activité."
        },
        {
            question: "Comment se déroule une mission de conseil ?",
            answer: "La mission se déroule généralement en plusieurs étapes : Prise de contact et diagnostic initial : Nous échangeons sur vos besoins et vos objectifs. Proposition d'intervention : Nous vous présentons une proposition détaillée (méthodologie, calendrier, livrables, honoraires). Collecte et analyse des données : Nous recueillons et analysons les informations pertinentes (données financières, entretiens avec les équipes, etc.). Élaboration des recommandations : Nous formulons des recommandations stratégiques et opérationnelles. Présentation des conclusions : Nous vous présentons les résultats de notre analyse et nos recommandations. Accompagnement à la mise en œuvre (facultatif) : Nous pouvons vous accompagner dans la mise en œuvre des recommandations. Suivi: nous assurons un suivi régulier pour mesurer l'impact des actions mises en place et ajuster la stratégie si nécessaire."
        },
        {
            question: "Pouvez-vous m'aider à préparer un dossier de demande de financement ?",
            answer: "Oui, nous avons une solide expérience dans l'élaboration de dossiers de financement pour les banques, les investisseurs et les organismes publics."
        }
    ];

    const servicesData = [
        {
            icon: <FaChartLine />,
            title: "Stratégie de croissance",
            description: "Élaboration et mise en œuvre de stratégies de croissance interne, externe ou de diversification adaptées à vos objectifs et à votre marché.",
            color: "#ffc107"
        },
        {
            icon: <FaLightbulb />,
            title: "Stratégie d'innovation",
            description: "Identification des opportunités d'innovation, mise en place de processus d'innovation et développement de nouveaux produits ou services.",
            color: "#fd7e14"
        },
        {
            icon: <FaRocket />,
            title: "Stratégie digitale",
            description: "Accompagnement dans votre transformation digitale, optimisation de votre présence en ligne et développement de nouveaux canaux digitaux.",
            color: "#198754"
        },
        {
            icon: <FaMoneyBillWave />,
            title: "Stratégie financière",
            description: "Optimisation de votre structure financière, recherche de financements, gestion de trésorerie et planification financière à long terme.",
            color: "#0d6efd"
        },
        {
            icon: <FaGlobeAmericas />,
            title: "Développement international",
            description: "Accompagnement dans votre expansion internationale, identification des marchés cibles et adaptation de votre offre aux spécificités locales.",
            color: "#dc3545"
        },
        {
            icon: <FaLeaf />,
            title: "Stratégie RSE",
            description: "Intégration des enjeux sociaux et environnementaux dans votre stratégie d'entreprise pour un développement durable et responsable.",
            color: "#20c997"
        },
        {
            icon: <FaExchangeAlt />,
            title: "Transmission d'entreprise",
            description: "Préparation et accompagnement dans la transmission ou la cession de votre entreprise, valorisation et optimisation fiscale.",
            color: "#6f42c1"
        }
    ];

    const advantagesData = [
        {
            icon: <FaRegCompass />,
            title: "Vision Stratégique",
            color: "#ffc107"
        },
        {
            icon: <FaRegChartBar />,
            title: "Performance Optimisée",
            color: "#dc3545"
        },
        {
            icon: <FaRegLightbulb />,
            title: "Décisions Éclairées",
            color: "#0d6efd"
        },
        {
            icon: <FaRegEdit />,
            title: "Solutions Sur-Mesure",
            color: "#198754"
        }
    ];

    const methodologySteps = [
        {
            number: 1,
            title: "Immersion et Compréhension",
            description: "Échanges approfondis avec vous et vos équipes pour comprendre votre histoire, votre culture, vos valeurs et vos aspirations. Analyse de votre modèle économique, de votre organisation et de vos ressources."
        },
        {
            number: 2,
            title: "Analyse Stratégique",
            description: "Étude de votre marché, de votre positionnement concurrentiel et de votre environnement externe (PESTEL). Identification de vos forces, faiblesses, opportunités et menaces (SWOT). Évaluation de vos avantages concurrentiels."
        },
        {
            number: 3,
            title: "Co-construction de la Stratégie",
            description: "Définition de votre vision et de vos objectifs stratégiques. Élaboration de scénarios stratégiques et évaluation de leurs impacts. Choix de la stratégie la plus adaptée et définition des plans d'action."
        },
        {
            number: 4,
            title: "Mise en Œuvre et Suivi",
            description: "Accompagnement dans le déploiement de la stratégie. Mise en place d'indicateurs de performance (KPI). Suivi régulier des résultats et ajustement de la stratégie si nécessaire."
        }
    ];

    return (
        <>
            <Header />

            <section className="service-banner d-flex align-items-center">
                <div className="container-fluid px-4 px-md-5 text-white">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="fw-bold display-4 mb-3">Conseil et Stratégie d'Entreprise</h1>
                            <p className="fs-5 mb-4">Des solutions stratégiques sur-mesure pour propulser votre entreprise vers le succès</p>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/" className="text-white text-decoration-none">
                                            Accueil
                                        </Link>{" "}
                                        /{" "}
                                        <Link to="/services" className="text-white text-decoration-none">
                                            Services
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">
                                        Conseil et Stratégie
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="fw-bold custom-title text-center mb-5">
                                CINEF-EC vous accompagne dans toutes les étapes de la vie de votre entreprise, de la création à la transmission.
                            </h2>
                            <p className="text-muted text-center fs-5 mb-5">
                                Notre approche globale et notre expertise pluridisciplinaire nous permettent de vous apporter des solutions stratégiques sur-mesure, adaptées à vos enjeux et à vos ambitions.
                            </p>
                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="bg-light p-5 rounded-3">
                                <h3 className="fw-bold custom-title mb-4">
                                    Notre méthodologie pour votre réussite
                                </h3>
                                {methodologySteps.map((step, index) => (
                                    <ProcessStep key={index} delay={`${index * 0.2}s`}>
                                        <StepNumber>{step.number}</StepNumber>
                                        <StepContent>
                                            <StepTitle>{step.title}</StepTitle>
                                            <StepDescription>{step.description}</StepDescription>
                                        </StepContent>
                                    </ProcessStep>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            <Section background="#f8f9fa">
                <div className="container-fluid px-4 px-md-5">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="fw-bold mb-1">Nos domaines d'expertise</h2>
                            <div className="d-inline-block mb-4">
                                <div className="custom-underline mx-auto"></div>
                            </div>
                            <p className="text-muted fs-5 mb-5">Des solutions adaptées à chaque défi stratégique</p>
                        </div>
                    </div>

                    <div className="row">
                        {servicesData.slice(0, 3).map((service, index) => (
                            <div className="col-md-6 col-lg-4 mb-4" key={index}>
                                <ServiceCard delay={`${index * 0.1}s`}>
                                    <ServiceIcon color={service.color}>{service.icon}</ServiceIcon>
                                    <ServiceTitle>{service.title}</ServiceTitle>
                                    <ServiceDescription>{service.description}</ServiceDescription>
                                </ServiceCard>
                            </div>
                        ))}
                    </div>

                    <div className="row">
                        {servicesData.slice(3, 6).map((service, index) => (
                            <div className="col-md-6 col-lg-4 mb-4" key={index + 3}>
                                <ServiceCard delay={`${(index + 3) * 0.1}s`}>
                                    <ServiceIcon color={service.color}>{service.icon}</ServiceIcon>
                                    <ServiceTitle>{service.title}</ServiceTitle>
                                    <ServiceDescription>{service.description}</ServiceDescription>
                                </ServiceCard>
                            </div>
                        ))}
                    </div>

                    <div className="row justify-content-center">
                        {servicesData.slice(6).map((service, index) => (
                            <div className="col-md-6 col-lg-4 mb-4" key={index + 6}>
                                <ServiceCard delay={`${(index + 6) * 0.1}s`}>
                                    <ServiceIcon color={service.color}>{service.icon}</ServiceIcon>
                                    <ServiceTitle>{service.title}</ServiceTitle>
                                    <ServiceDescription>{service.description}</ServiceDescription>
                                </ServiceCard>
                            </div>
                        ))}
                    </div>
                </div>
            </Section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row justify-content-center mb-5">
                        <div className="col-12 col-md-10 col-lg-8">
                            <div className="call-to-action p-5 rounded-3 text-center">
                                <h3 className="fw-bold text-white mb-3">Prêt à propulser votre entreprise vers le succès ?</h3>
                                <p className="text-white fs-5 mb-4">
                                    Nos experts sont à votre disposition pour vous accompagner dans l'élaboration et la mise en œuvre de votre stratégie d'entreprise.
                                    Contactez-nous dès aujourd'hui pour une consultation gratuite et découvrez comment nous pouvons vous aider à atteindre vos objectifs.
                                </p>
                                <a href="/contact" className="btn btn-light btn-lg fw-bold px-4">Demander une consultation gratuite</a>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-12 text-center mb-5">
                            <h3 className="fw-bold">Les bénéfices de notre accompagnement</h3>
                            <div className="d-inline-block mb-4">
                                <div className="custom-underline mx-auto"></div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        {advantagesData.map((item, index) => (
                            <div className="col-6 col-md-3" key={index}>
                                <AdvantageCard>
                                    <AdvantageIcon color={item.color}>{item.icon}</AdvantageIcon>
                                    <p className="fw-bold fs-5 mb-0">{item.title}</p>
                                </AdvantageCard>
                            </div>
                        ))}
                    </div>
                </div>
            </Section>

            <Section background="#f8f9fa" id="faq-section" className={isVisible ? 'visible' : ''}>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h3 className="fw-bold">Questions Fréquentes sur le Conseil en Stratégie</h3>
                            <div className="d-inline-block mb-4">
                                <div className="custom-underline mx-auto"></div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <FAQContainer>
                                <FAQContent>
                                    {faqData.map((faq, index) => (
                                        <FAQItem key={index} delay={`${index * 0.2}s`}>
                                            <Question onClick={() => toggleFAQ(index)}>
                                                {faq.question}
                                                <Icon isOpen={activeIndex === index}>{activeIndex === index ? "−" : "+"}</Icon>
                                            </Question>
                                            {activeIndex === index && <Answer>{faq.answer}</Answer>}
                                        </FAQItem>
                                    ))}
                                </FAQContent>
                            </FAQContainer>
                        </div>
                    </div>
                </div>
            </Section>

            <Footer />

            <style>{`
        .service-banner {
          background: linear-gradient(to right, #008a44, #dc3545), 
                      url("/assets/images/image-conseil-strategie.png");
          background-size: cover;
          background-position: center;
          height: 400px;
          display: flex;
          align-items: center;
        }

        .breadcrumb {
          background: transparent;
          font-size: 18px;
        }

        .breadcrumb-item a {
          color: white;
          font-weight: 500;
        }

        .custom-title {
          position: relative;
          padding-bottom: 15px;
        }

        .custom-title:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(to right, #008a44, #dc3545);
        }

        .text-center .custom-title:after {
          left: 50%;
          transform: translateX(-50%);
        }

        .custom-underline {
          height: 4px;
          width: 70px;
          background: linear-gradient(to right, #008a44, #dc3545);
          margin-top: 10px;
        }

        .call-to-action {
          background: linear-gradient(to right, #008a44, #dc3545);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        #faq-section {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s ease;
        }

        #faq-section.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        @media (max-width: 768px) {
          .service-banner {
            height: 350px;
          }
          
          .custom-title {
            font-size: 1.75rem;
          }
        }
      `}</style>
        </>
    );
};

export default ConseilStrategie;